export const USER_GET_HOSPITAL_ENDPOINT = `tenants/networks/hospitals/`;
export const USER_GET_HOSPITAL_INFO_ENDPOINT = `tenants/networks/hospitals/contacts`;
export const USER_GET_HOSPITAL_CLINICAL_PHARMACY_INFO_ENDPOINT = `tenants/networks/hospitals/clinical-pharmacies/contacts`;
export const USER_GET_HOSPITAL_LOGOS_ENDPOINT = `logos/`;
export const USER_GET_TENANTS_ENDPOINT = `tenants/`;
export const USER_GET_PERMISSIONS_ENDPOINT = `users/permissions/without-hierarchy`;
export const USER_GET_APPS_ENDPOINT = `users/apps`;
